import { render, staticRenderFns } from "./MarginDetail.vue?vue&type=template&id=46b8c154&scoped=true&"
import script from "./MarginDetail.vue?vue&type=script&lang=js&"
export * from "./MarginDetail.vue?vue&type=script&lang=js&"
import style0 from "./MarginDetail.vue?vue&type=style&index=0&id=46b8c154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b8c154",
  null
  
)

export default component.exports